import EditBandDetailType from './edit-band-limit.types'

export const setEditBandDetail = data =>({
    type: EditBandDetailType.SET_EDIT_BAND_DETAIL,
payload: data
})
